import { styled } from '@mui/material';
import { Checkbox } from 'core/common/ui/ui-kit';

export const WrapperStyled = styled('div')`
  max-width: 300px;
  margin-bottom: 24px;
`;

export const ContainerStyled = styled('div')`
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
  font-size: 12px;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const CheckboxStyled = styled(Checkbox)`
  margin-right: 8px;
  padding: 0;
`;

export const CheckboxTextStyled = styled('span')``;
